module.exports = __webpack_public_path__ + "static/media/gg.b349bf9b.svg";